import { combineReducers } from 'redux';

import { authentication } from './authentication/authentication';
import { cashback } from './cashback/cashback';
import { countries } from './countries/countries';
import { currencies } from './currencies/currencies';
import { documentFiles } from './documentFiles/documentFiles';
import { documents } from './documents/documents';
import { documentsCollection } from './documentsCollection/documentsCollection';
import { errors } from './errors/errors';
import { extendedUser } from './extendedUser/extendedUser';
import { fees } from './fees/fees';
import { fields } from './fields';
import { instructions } from './instructions/instructions';
import { items } from './items/items';
import { kyc } from './kyc/kyc';
import { legacyRecurringOffers } from './legacyRecurringOffers/legacyRecurringOffers';
import { links } from './links/links';
import { lrs } from './lrs/lrs';
import { offers } from './offers/offers';
import { order } from './order/order';
import { payment } from './payment/payment';
import { payments } from './payments/payments';
import { payouts } from './payouts/payouts';
import { prices } from './prices/prices';
import { proofFiles } from './proofFiles/proofFiles';
import { proofs } from './proofs/proofs';
import { purchases } from './purchases/purchases';
import { recipient } from './recipient/recipient';
import { recipients } from './recipients/recipients';
import { recurringOffers } from './recurringOffers/recurringOffers';
import { recurringReceivables } from './recurringReceivables/recurringReceivables';
import { refunds } from './refunds/refunds';
import { repeatPaymentOffer } from './repeatPaymentOffer/repeatPaymentOffer';
import { sections } from './sections';
import { selected } from './selected';
import { smsNotifications } from './smsNotifications/smsNotifications';
import { user } from './user/user';

const entities = combineReducers({
  authentication,
  cashback,
  countries,
  currencies,
  documentFiles,
  documents,
  documentsCollection,
  errors,
  extendedUser,
  fees,
  fields,
  instructions,
  items,
  kyc,
  links,
  lrs,
  offers,
  order,
  payment,
  payments,
  payouts,
  prices,
  proofFiles,
  proofs,
  purchases,
  recipient,
  recipients,
  legacyRecurringOffers,
  recurringOffers,
  recurringReceivables,
  refunds,
  repeatPaymentOffer,
  sections,
  selected,
  smsNotifications,
  user,
});

export { entities };
